import React, { useState } from 'react';

import { Box, Button, Container, Grid, Switch } from '@mui/material';

import Form from '@rjsf/mui';
import validator from '@rjsf/validator-ajv8';

import { JSONSchema7 } from 'json-schema';
import PrimaryLayout from "../../components/layout/PrimaryLayout";
import { useKeycloak } from '../../KeycloakProvider';
import { Api } from "../../services/workflow-server";
import { axiosWorkflowIntance } from '../../services/api-client';
import { useNavigate } from 'react-router-dom';

const AddNamespace2: React.FC = () => {
    const { keycloak } = useKeycloak();
    const [historyArchivalEnabled, setHistoryArchivalEnabled] = useState(false);
    const [visibilityArchivalEnabled, setVisibilityArchivalEnabled] = useState(false);
    const [formData, setFormData] = useState<any>({});
    const navigate = useNavigate();

    const apiClient = new Api({
        baseURL: 'http://wapi.centurion.localhost',
    });

    const schema: JSONSchema7 = {
        type: "object",
        properties: {
            namespace: {
                type: "string",
                title: "Namespace",
                minLength: 3
            },
            description: {
                type: "string",
                title: "Description",
            },
            workflowExecutionRetentionPeriod: {
                type: "number",
                title: "Retention Period (Hours)"
            },
            historyArchivalState: {
                type: "number",
                default: 0,
                title: "History Archival State",
                enum: [0, 1]
            },
            ...(historyArchivalEnabled && {
                historyArchivalUri: {
                    type: "string",
                    title: "History Archival URI",
                    format: "uri"
                }
            }),
            visibilityArchivalState: {
                type: "number",
                title: "Visibility Archival State",
                default: 0,
                enum: [0, 1]
            },
            ...(visibilityArchivalEnabled && {
                visibilityArchivalUri: {
                    type: "string",
                    title: "Visibility Archival URI",
                    format: "uri"
                }
            }),
            data: {
                type: "object",
                title: "Meta Data",
                additionalProperties: {
                    type: "string"
                }
            },
        },
        required: ["namespace", "workflowExecutionRetentionPeriod", "historyArchivalState", "visibilityArchivalState"]
    };

    const uiSchema = {
        namespace: {
            "ui:autofocus": true,
            "ui:placeholder": "Enter namespace"
        },
        description: {
            "ui:widget": "textarea",
            "ui:placeholder": "Enter a description"
        },
        workflowExecutionRetentionPeriod: {
            "ui:widget": "updown",
            "ui:help": "Specify the number of hours the workflow history should be retained. After this period, the history will be deleted."
        },
        historyArchivalState: {
            "ui:widget": (props: { label: any; value: number; onChange: (arg0: number) => void; }) => (
                <div>
                    <label>{props.label}</label>
                    <Switch
                        checked={historyArchivalEnabled === true}
                        onChange={(event) => {
                            const enabled = event.target.checked;
                            props.onChange(enabled ? 1 : 0);
                            setHistoryArchivalEnabled(enabled);
                        }}
                        name="history_archival_state"
                    />
                    <span>{props.value === 1 ? 'Enabled' : 'Disabled'}</span>
                </div>
            ),
            "ui:help": "If enabled, the history will be stored in a specified location for long-term access and analysis."
        },
        historyArchivalUri: {
            "ui:placeholder": "Enter the URI for history archival",
            "ui:help": "Specify the URI where the archived workflow history should be stored. This is required if you enable history archival."
        },
        visibilityArchivalState: {
            "ui:widget": (props: { label: any; value: number; onChange: (arg0: number) => void; }) => (
                <div>
                    <label>{props.label}</label>
                    <Switch
                        checked={visibilityArchivalEnabled === true}
                        onChange={(event) => {
                            const enabled = event.target.checked;
                            props.onChange(enabled ? 1 : 0);
                            setVisibilityArchivalEnabled(enabled);
                        }}
                        name="visibility_archival_state"
                    />
                    <span>{props.value === 1 ? 'Enabled' : 'Disabled'}</span>
                </div>
            ),
            "ui:help": "If enabled, these records will be stored in a specified location for future search and reporting."
        },
        visibilityArchivalUri: {
            "ui:placeholder": "Enter the URI for visibility archival",
            "ui:help": "Specify the URI where the archived visibility records should be stored. This is required if you enable visibility archival."
        }
    };

    const onSubmit = async ({ formData }: any) => {
        try {
            const ownerEmail = keycloak.tokenParsed?.email || '';
            const formattedData = {
                ...formData,
                ownerEmail,
                workflowExecutionRetentionPeriod: `${formData.workflowExecutionRetentionPeriod}h`
            };
            await axiosWorkflowIntance.api.workflowServiceRegisterNamespace(formattedData);
            alert('Namespace registered successfully!');
            navigate("/namespaces")
        } catch (error) {
            console.error('Error registering namespace:', error);
            alert('Failed to register namespace. Please try again.');
        }
    };

    return (
        <PrimaryLayout>
            <Container>
                <Grid container justifyContent="space-between" alignItems="center">
                    <h1>Add Namespace</h1>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        onClick={() => document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}>
                        Submit
                    </Button> */}
                </Grid>
                <Form
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    onChange={(e) => setFormData(e.formData)}
                    onSubmit={onSubmit}
                    validator={validator}
                />
                {/* <Box textAlign="right">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}>
                        Submit
                    </Button>
                </Box> */}
            </Container>
        </PrimaryLayout>
    );
};

export default AddNamespace2;
